import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { TPrinter } from "redux/reducers/models/facility";

type TPostFacilityPrinter = {
  title: string;
  connection_type: string;
};

type TPutFacilityPrinter = {
  id: number;
  title: string;
  connection_type: string;
};

// GET A Single Printer
export async function GetPrinter(params: { id: string | number }, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<TPrinter>(APIUrl(AdminType.FacilityAdmin, "/facility/printer"), params, useGlobalLoader, token);
}

// GET A Single Printer
export async function GetPrinterAll(params: { id?: string | number }, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<TPrinter[]>(
    APIUrl(AdminType.FacilityAdmin, "/facility/printer/all"),
    params,
    useGlobalLoader,
    token,
  );
}

// POST Printers
export async function PostPrinter(params: TPostFacilityPrinter, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/printer"), params, useGlobalLoader);
}

// Put Printers
export async function PutPrinter(params: TPutFacilityPrinter, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/printer"), params, useGlobalLoader);
}

// Delete Printer
export async function DeletePrinter(params: { id: string | number }, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/facility/printer"), params, useGlobalLoader);
}
